<template>
  <!--票务系统-->
  <article>
    <div class="caption">
      <h2>运维服务</h2>
      <span>OPERATIONS AND MAINTENANCE SERVICES</span>
    </div>

    <div class="content">
      网络主权是国家主权在网络空间的表现与延伸，网络技术发展与安全是国家综合力的重要表现。景区网络系统的安全会给景区带来损失，甚至会影响景区的生存和发展
    </div>

    <div class="grid">
      <div v-for="item in data" :key="item.title" class="item">
        <img :src="item.img" alt="" srcset="">
        <h4>{{item.title}}</h4>
        <h5>{{item.subtitle}}</h5>
        <p>{{item.content}}</p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data: function() {
    return {
      data: [
        {
          img: require("@/assets/images/product/ops/item-1.png"),
          title: "社会工程学",
          subtitle: "Social Engineering",
          content:
            "社会工程学的培训是为了管理者、系统权限较高者，对相关的攻击手段有基本的防范不至于犯低级的错误"
        },
        {
          img: require("@/assets/images/product/ops/item-2.png"),
          title: "安全服务",
          subtitle: "Security Service",
          content: "漏洞扫描、入侵检测病毒库升级、资产脆弱性检查"
        },
        {
          img: require("@/assets/images/product/ops/item-3.png"),
          title: "威胁情报",
          subtitle: "Threat Intelligence",
          content:
            "与国内顶尖安全机构启明星辰共享全球安全预警资源第一时间关注行业突发事"
        },
        {
          img: require("@/assets/images/product/ops/item-4.png"),
          title: "态势感知",
          subtitle: "Situation Awareness",
          content:
            "基于威胁情报为基础，依托行业经验，贴合系统本身，而进行快速判断给出决策与行动"
        },
        {
          img: require("@/assets/images/product/ops/item-5.png"),
          title: "等保2.0三级",
          subtitle: "Level III Standards",
          content:
            "从软件设计到物理环境规划，严格遵循国家等保2.0三级标准，为合作伙伴保驾护航"
        },
        {
          img: require("@/assets/images/product/ops/item-6.png"),
          title: "双线路架构设计",
          subtitle: "Dual-line Architecture",
          content:
            "采用ISP运营商主流城域网架构，目前已在故宫景区正式环境运行三年断网率“零”、可用率100%"
        },
        {
          img: require("@/assets/images/product/ops/item-7.png"),
          title: "同城双中心",
          subtitle: "Double Centre",
          content:
            "日常情况：可同时分担业务及管理系统的运行并可切换运行。灾难情况：可有效防止突发性断网断电而引发的系统不可使用，核心数据丢失"
        },
        {
          img: require("@/assets/images/product/ops/item-8.png"),
          title: "定制化驻场服务",
          subtitle: "Customized Resident Service",
          content:
            "为使用方提供全天候的驻场服务，提供软件技术支持、相关硬件巡检、系统日常维护、需求迭代整理四大定制服务"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
article {
  display: flex;
  flex-direction: column;

  > .caption {
    display: flex;
    flex-direction: column;
    align-items: center;
    > h2 {
      display: inline-block;
      border-bottom: 2px solid #666666;
      padding-bottom: 5px;
      font-size: 24px;
    }

    span {
      font-size: 14px;
      font-weight: lighter;
    }
  }

  > .content {
    margin: 20px 0;
    text-align: center;
    font-size: 14px;
  }

  > .grid {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 24%;
      padding: 20px;
      // border: 1px solid blue;

      > img {
        width: 75px;
        height: 75px;
        margin: 20px 0;
      }

      > h4 {
        font-size: 18px;
        font-weight: bold;
      }

      > h5 {
        font-size: 14px;
        font-weight: lighter;
        margin-bottom: 15px;
      }

      > p {
        font-size: 0.06rem;
        line-height: 0.12rem;
      }
    }
  }
}
</style>